import { render, staticRenderFns } from "./BackdropVideo.vue?vue&type=template&id=d79f6fa2&scoped=true&"
import script from "./BackdropVideo.vue?vue&type=script&lang=js&"
export * from "./BackdropVideo.vue?vue&type=script&lang=js&"
import style0 from "./BackdropVideo.vue?vue&type=style&index=0&id=d79f6fa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79f6fa2",
  null
  
)

export default component.exports